import {computed, ComputedRef} from "vue"
import { transportPacks } from "@/config/transportPackagePriorities"
import store from "@/vue/planning/store/store"

const availableFlightPackCodes: ComputedRef<Array<any>> = computed(() => {
    const availableFlightPackCodes = store.getters.availablePackCodes.filter((codeObjPackage: any) => {
        if (transportPacks.includes(codeObjPackage.codePackage)) return true;
    });

    return availableFlightPackCodes;
})

export default availableFlightPackCodes